import React,{useState} from "react";
import {isMobile} from 'react-device-detect';
import {
    extractAdditionalArticlesElements,
  } from '../ArticlePagesBlock/utilities';
import {AdditionalArticles} from '../ArticlePagesBlock/AdditionalArticles';
import BtnWhiteBlackBorderBigSize from '../../Shared/Buttons/BtnWhiteBlackBorderBigSize';
import {Swiper, SwiperSlide} from 'swiper/react';
export const MainAdditionalArticles=(props)=>{
    const content = {   
        mainHeading: isMobile?props.contentData?.mainHeadingMobile?.value :props.contentData?.mainHeading?.value,
        btnText: props.contentData?.btnText?.value,
        btnTextAfterClicked: props.contentData?.btnTextAfterClicked?.value,
        additionalArticles: extractAdditionalArticlesElements(props.contentData?.additionalArticles?.expandedValue),
    };
      const [desktopArticles, setDesktopArticles] = useState([...content.additionalArticles.slice(0, 3)]);
      const [additionalBtnText, setBtnText] = useState(content.btnText);
      const [showAdditional, setAdditionalDisplay] = useState(false);
      const handleMoreArticlesClick = () => {
        if (showAdditional) {
          setDesktopArticles(content.additionalArticles);
          setBtnText(content.btnTextAfterClicked);
        } else {
          setDesktopArticles(content.additionalArticles.slice(0, 3));
          setBtnText(content.btnText);
        }
      };
    
return (
        <div className={!isMobile? 'additional-articles-section-container':'additional-articles-section-container-mobile'}>
          <div className='heading'>{content.mainHeading}</div>
          <div className={desktopArticles.length>1?'additional-articles-container':'additional-articles-container single-element'}>
            {!isMobile ? (
              desktopArticles?.reverse().map((element, i) => {
                return <AdditionalArticles element={element} key={i} context={props.context} />;
              })
            ) : (
              <Swiper
                spaceBetween={5}
                centeredSlides
                lidesPerView={ desktopArticles.length>1 ? 1.2 : 1}
                pagination={{clickable: true}}
                className='d-block d-md-none'
                style={{paddingTop: '10px', paddingBottom: '10px'}}>
                {content.additionalArticles?.map((element, i) => (
                  <SwiperSlide key={i}>
                    <AdditionalArticles element={element} key={i} context={props.context} />
                  </SwiperSlide>
                ))}
              </Swiper>
            )}
          </div>
          {!isMobile && content.additionalArticles?.length > 3 && (
            <BtnWhiteBlackBorderBigSize
              onclick={() => {
                setAdditionalDisplay(!showAdditional);
                handleMoreArticlesClick();
              }}
              text={additionalBtnText}
            />
          )}
        </div>
      
);
}